import { BasketItem } from '../../../core/state/order/order.types';

const uniqueItemId = ({ itemId, options }: BasketItem) =>
  JSON.stringify({
    [itemId]: options,
  });

export const basketUtils = {
  uniqueItemId,
};
